import React, { useState } from 'react';
import { Mail, Lock, Eye, EyeOff, Loader2, LogIn } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';

const LoginForm = ({ LoginFunction }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      // LoginFunction handles navigation + toasts; keep the field values so the
      // user can retry on failure without retyping.
      await LoginFunction(formData.email, formData.password);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="login-form">
      <div className="form-group">
        <div className="input-icon">
          <Mail size={18} />
          <input
            type="text"
            inputMode="email"
            name="email"
            placeholder={t('login.emailPlaceholder')}
            value={formData.email}
            onChange={handleChange}
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            disabled={submitting}
            required
          />
          <span className="focus-border" />
        </div>
      </div>

      <div className="form-group">
        <div className="input-icon">
          <Lock size={18} />
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder={t('login.password')}
            value={formData.password}
            onChange={handleChange}
            autoComplete="current-password"
            disabled={submitting}
            required
          />
          <button
            type="button"
            className="toggle-password"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? t('login.hidePassword') : t('login.showPassword')}
            tabIndex={-1}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
          <span className="focus-border" />
        </div>
      </div>

      <button type="submit" className="login-btn" disabled={submitting} aria-busy={submitting}>
        {submitting ? (
          <>
            <Loader2 size={18} className="login-spin" />
            {t('login.signingIn')}
          </>
        ) : (
          <>
            <LogIn size={18} />
            {t('login.signIn')}
          </>
        )}
      </button>
    </form>
  );
};

export default LoginForm;
